import { Component, Inject } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-confirmation-popup',
    templateUrl: './confirmation-popup.component.html',
    styleUrl: './confirmation-popup.component.sass',
    standalone: false
})

export class ConfirmationPopupComponent {

  message: string = 'Are you sure you want to proceed?';
  safeMessage: SafeHtml;

  constructor(private dialogRef: MatDialogRef<any>,
              @Inject(MAT_DIALOG_DATA) public data: { message: string, isHtml?: boolean },
              private sanitizer: DomSanitizer) {          
    if(data && data.message) {
      this.message = data.message;
    }
    this.safeMessage = data?.isHtml
      ? this.sanitizer.bypassSecurityTrustHtml(data.message)
      : data?.message ?? '';
  }

  closeDialog(confirmed: boolean): void {
    this.dialogRef.close(confirmed);
  }

}